import { EntryProps, getLogEntryAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

export const ConversationPending = ({ entry }: EntryProps): JSX.Element => {
  const authorName = getLogEntryAuthorName(entry);
  const authorLink = authorName ? (
    <UserLink userId={entry.author.id}>{authorName}</UserLink>
  ) : null;

  const text = (
    <>Conversation is pending {authorLink && <>by {authorLink}</>}</>
  );

  return <LogEntry entry={entry} text={text} />;
};
